module.exports = __webpack_public_path__ + "static/assets/ccca042c251544aa8caa5a9bc6b8afbe.jpg";